<div class="avatar-cropper">
  <div class="dialog-header">
    <div class="title">
      <span>{{ 'Adjust your avatar' | translate }}</span>
    </div>
    <button
      type="button"
      class="close-btn"
      [attr.aria-label]="'Close' | translate"
      [andorTooltip]="'Close' | translate"
      tooltipPosition="below"
      (click)="cancel()">
      <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
    </button>
  </div>

  @if (error()) {
    <p class="cropper-error">{{ error()! | translate }}</p>
  }

  <div class="stage">
    <div
      class="frame"
      [style.width.px]="framePx"
      [style.height.px]="framePx"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp()"
      (pointercancel)="onPointerUp()"
      (pointerleave)="onPointerUp()"
      (wheel)="onWheel($event)">
      @if (!loading()) {
        <img class="source" [src]="imageUrl()" [ngStyle]="imageStyle()" draggable="false" alt="" />
      }
      <div class="mask"></div>
    </div>
  </div>

  <div class="zoom">
    <fa-duotone-icon [icon]="faMinus"></fa-duotone-icon>
    <input
      type="range"
      min="1"
      [max]="maxZoom"
      step="0.01"
      [value]="zoom()"
      [disabled]="loading()"
      (input)="onZoomInput(+$any($event.target).value)"
      [attr.aria-label]="'Zoom' | translate" />
    <fa-duotone-icon [icon]="faPlus"></fa-duotone-icon>
  </div>

  <div class="actions">
    <andor-button (click)="cancel()">
      <span>{{ 'Cancel' | translate }}</span>
    </andor-button>
    <andor-button type="gradient" [disabled]="loading() || saving()" (click)="apply()">
      <span>{{ (saving() ? 'Saving…' : 'Apply') | translate }}</span>
    </andor-button>
  </div>
</div>
